/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WeeklyUserAnalyticsResponse
 */
export interface WeeklyUserAnalyticsResponse {
    /**
     * 
     * @type {number}
     * @memberof WeeklyUserAnalyticsResponse
     */
    total_subscribed_accounts: number;
    /**
     * 
     * @type {number}
     * @memberof WeeklyUserAnalyticsResponse
     */
    weekly_active_subscribed: number;
    /**
     * 
     * @type {number}
     * @memberof WeeklyUserAnalyticsResponse
     */
    weekly_active_subscribed_percentage: number;
    /**
     * 
     * @type {number}
     * @memberof WeeklyUserAnalyticsResponse
     */
    total_unsubscribed_accounts: number;
    /**
     * 
     * @type {number}
     * @memberof WeeklyUserAnalyticsResponse
     */
    weekly_active_unsubscribed: number;
    /**
     * 
     * @type {number}
     * @memberof WeeklyUserAnalyticsResponse
     */
    weekly_active_unsubscribed_percentage: number;
    /**
     * 
     * @type {number}
     * @memberof WeeklyUserAnalyticsResponse
     */
    connect_count: number;
    /**
     * 
     * @type {number}
     * @memberof WeeklyUserAnalyticsResponse
     */
    ops_count: number;
    /**
     * 
     * @type {number}
     * @memberof WeeklyUserAnalyticsResponse
     */
    respond_count: number;
    /**
     * 
     * @type {number}
     * @memberof WeeklyUserAnalyticsResponse
     */
    weekly_active_connect: number;
    /**
     * 
     * @type {number}
     * @memberof WeeklyUserAnalyticsResponse
     */
    weekly_active_ops: number;
    /**
     * 
     * @type {number}
     * @memberof WeeklyUserAnalyticsResponse
     */
    weekly_active_respond: number;
}

/**
 * Check if a given object implements the WeeklyUserAnalyticsResponse interface.
 */
export function instanceOfWeeklyUserAnalyticsResponse(value: object): value is WeeklyUserAnalyticsResponse {
    if (!('total_subscribed_accounts' in value) || value['total_subscribed_accounts'] === undefined) return false;
    if (!('weekly_active_subscribed' in value) || value['weekly_active_subscribed'] === undefined) return false;
    if (!('weekly_active_subscribed_percentage' in value) || value['weekly_active_subscribed_percentage'] === undefined) return false;
    if (!('total_unsubscribed_accounts' in value) || value['total_unsubscribed_accounts'] === undefined) return false;
    if (!('weekly_active_unsubscribed' in value) || value['weekly_active_unsubscribed'] === undefined) return false;
    if (!('weekly_active_unsubscribed_percentage' in value) || value['weekly_active_unsubscribed_percentage'] === undefined) return false;
    if (!('connect_count' in value) || value['connect_count'] === undefined) return false;
    if (!('ops_count' in value) || value['ops_count'] === undefined) return false;
    if (!('respond_count' in value) || value['respond_count'] === undefined) return false;
    if (!('weekly_active_connect' in value) || value['weekly_active_connect'] === undefined) return false;
    if (!('weekly_active_ops' in value) || value['weekly_active_ops'] === undefined) return false;
    if (!('weekly_active_respond' in value) || value['weekly_active_respond'] === undefined) return false;
    return true;
}

export function WeeklyUserAnalyticsResponseFromJSON(json: any): WeeklyUserAnalyticsResponse {
    return WeeklyUserAnalyticsResponseFromJSONTyped(json, false);
}

export function WeeklyUserAnalyticsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeeklyUserAnalyticsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total_subscribed_accounts': json['totalSubscribedAccounts'],
        'weekly_active_subscribed': json['weeklyActiveSubscribed'],
        'weekly_active_subscribed_percentage': json['weeklyActiveSubscribedPercentage'],
        'total_unsubscribed_accounts': json['totalUnsubscribedAccounts'],
        'weekly_active_unsubscribed': json['weeklyActiveUnsubscribed'],
        'weekly_active_unsubscribed_percentage': json['weeklyActiveUnsubscribedPercentage'],
        'connect_count': json['connectCount'],
        'ops_count': json['opsCount'],
        'respond_count': json['respondCount'],
        'weekly_active_connect': json['weeklyActiveConnect'],
        'weekly_active_ops': json['weeklyActiveOps'],
        'weekly_active_respond': json['weeklyActiveRespond'],
    };
}

export function WeeklyUserAnalyticsResponseToJSON(json: any): WeeklyUserAnalyticsResponse {
    return WeeklyUserAnalyticsResponseToJSONTyped(json, false);
}

export function WeeklyUserAnalyticsResponseToJSONTyped(value?: WeeklyUserAnalyticsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalSubscribedAccounts': value['total_subscribed_accounts'],
        'weeklyActiveSubscribed': value['weekly_active_subscribed'],
        'weeklyActiveSubscribedPercentage': value['weekly_active_subscribed_percentage'],
        'totalUnsubscribedAccounts': value['total_unsubscribed_accounts'],
        'weeklyActiveUnsubscribed': value['weekly_active_unsubscribed'],
        'weeklyActiveUnsubscribedPercentage': value['weekly_active_unsubscribed_percentage'],
        'connectCount': value['connect_count'],
        'opsCount': value['ops_count'],
        'respondCount': value['respond_count'],
        'weeklyActiveConnect': value['weekly_active_connect'],
        'weeklyActiveOps': value['weekly_active_ops'],
        'weeklyActiveRespond': value['weekly_active_respond'],
    };
}

